import React, { Component } from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import { toast } from "react-toastify";
import API from "../utils/api";

const BUY_PERCENTAGE_OPTIONS = [
  { label: "100%", value: "100" },
  { label: "90%", value: "90" },
  { label: "80%", value: "80" },
  { label: "70%", value: "70" },
  { label: "60%", value: "60" },
  { label: "50%", value: "50" },
  { label: "40%", value: "40" },
  { label: "30%", value: "30" },
  { label: "20%", value: "20" },
  { label: "0%", value: "0" },
];

class AdminSourceWisePostingReport extends Component {
  state = {
    from: "",
    to: "",
    service_type: "",
    service_for: [],
    medicine_type: [],
    location: [],
    buy_percentage: "",
    team_id: "",
    teams: [],
    rows: [],
    totals: { posted: 0, pending: 0, deleted: 0 },
    loading: true,
    medicineTypeOptions: [],
    serviceForOptions: [],
    serviceTypeOptions: [],
  };

  componentDidMount() {
    this.loadFilters();
    this.fetchReport();
  }

  loadFilters = async () => {
    try {
      const [constRes, teamsRes] = await Promise.all([
        API.get("/const-data"),
        API.get("/teams")
      ]);
      const constData = constRes.data.data || constRes.data || {};
      const teamsData = teamsRes.data.data || teamsRes.data;
      const teams = Array.isArray(teamsData) ? teamsData : [];
      this.setState({
        medicineTypeOptions: constData.medicine_type || [],
        serviceForOptions: constData.service_for || [],
        serviceTypeOptions: constData.enquiry_type || [],
        teams,
      });
    } catch (e) {
      console.error("Failed to load filter options", e);
    }
  };

  loadLocations = async (inputValue) => {
    if (!inputValue || inputValue.length < 2) return [];

    try {
      const res = await API.get("/cities", { params: { q: inputValue } });
      const cities = res.data.data || res.data || [];

      return cities.map((city) => ({
        value: `${city.city}, ${city.state}`,
        label: `${city.city}, ${city.state}`,
        id: city.id,
      }));
    } catch (e) {
      return [];
    }
  };

  fetchReport = async () => {
    this.setState({ loading: true });
    try {
      const { from, to, service_type, service_for, medicine_type, location, buy_percentage, team_id } = this.state;
      const params = {};

      if (from) params.from = from;
      if (to) params.to = to;
      if (service_type) params.service_type = service_type;
      if (service_for && service_for.length > 0) {
        params.service_for = service_for.map((item) => item.value).join(",");
      }
      if (medicine_type && medicine_type.length > 0) {
        params.medicine_type = medicine_type.map((item) => item.value).join(",");
      }
      if (location && location.length > 0) {
        params.location = JSON.stringify(location.map((item) => item.value));
      }
      if (buy_percentage) {
        params.buy_percentage = buy_percentage;
      }
      if (team_id) {
        params.team_id = team_id;
      }

      const res = await API.get("/admin/report/source-wise-posting", { params });
      const data = res.data.data || res.data || {};

      this.setState({
        rows: data.rows || [],
        totals: data.totals || { posted: 0, pending: 0, deleted: 0 },
        loading: false,
      });
    } catch (e) {
      toast.error("Failed to load source wise posting report");
      this.setState({ loading: false });
    }
  };

  handleSearch = (e) => {
    e.preventDefault();
    this.fetchReport();
  };

  handleReset = () => {
    this.setState(
      {
        from: "",
        to: "",
        service_type: "",
        service_for: [],
        medicine_type: [],
        location: [],
        buy_percentage: "",
        team_id: "",
      },
      this.fetchReport
    );
  };

  render() {
    const {
      from,
      to,
      service_type,
      service_for,
      medicine_type,
      location,
      buy_percentage,
      rows,
      totals,
      loading,
      medicineTypeOptions,
      serviceForOptions,
      serviceTypeOptions,
      team_id,
      teams,
    } = this.state;

    return (
      <div>
        <h2 className="page-header">
          <i className="fas fa-chart-line"></i> Source Wise Posting
        </h2>

        <form onSubmit={this.handleSearch} className="well" style={{ marginBottom: 20, padding: 15 }}>
          <div className="row">
            <div className="col-md-2">
              <div className="form-group">
                <label>From</label>
                <input
                  type="date"
                  className="form-control"
                  value={from}
                  onChange={(e) => this.setState({ from: e.target.value })}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>To</label>
                <input
                  type="date"
                  className="form-control"
                  value={to}
                  onChange={(e) => this.setState({ to: e.target.value })}
                />
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>Service Type</label>
                <select
                  className="form-control"
                  value={service_type}
                  onChange={(e) => this.setState({ service_type: e.target.value })}
                >
                  <option value="">All Service Types</option>
                  {serviceTypeOptions.map((s) => (
                    <option key={s} value={s}>
                      {s}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>Buy Percentage</label>
                <select
                  className="form-control"
                  value={buy_percentage}
                  onChange={(e) => this.setState({ buy_percentage: e.target.value })}
                >
                  <option value="">All</option>
                  {BUY_PERCENTAGE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>Team</label>
                <select
                  className="form-control"
                  value={team_id}
                  onChange={(e) => this.setState({ team_id: e.target.value })}
                >
                  <option value="">All Teams</option>
                  {teams.map((t) => (
                    <option key={t.id} value={t.id}>
                      {t.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-group">
                <label>&nbsp;</label>
                <div>
                  <button type="submit" className="btn btn-primary" style={{ marginRight: 8 }}>
                    <i className="fas fa-search"></i> Search
                  </button>
                  <button type="button" className="btn btn-default" onClick={this.handleReset}>
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4">
              <div className="form-group">
                <label>Service For</label>
                <Select
                  isMulti
                  isClearable
                  isSearchable
                  options={serviceForOptions.map((s) => ({ label: s, value: s }))}
                  value={service_for}
                  onChange={(selected) => this.setState({ service_for: selected || [] })}
                  placeholder="All service for values"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Medicine Type</label>
                <Select
                  isMulti
                  isClearable
                  isSearchable
                  options={medicineTypeOptions.map((s) => ({ label: s, value: s }))}
                  value={medicine_type}
                  onChange={(selected) => this.setState({ medicine_type: selected || [] })}
                  placeholder="All medicine types"
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label>Location</label>
                <AsyncSelect
                  isMulti
                  cacheOptions
                  defaultOptions={false}
                  loadOptions={this.loadLocations}
                  value={location}
                  onChange={(selected) => this.setState({ location: selected || [] })}
                  placeholder="Search city/state"
                  noOptionsMessage={() => "Type at least 2 characters"}
                />
              </div>
            </div>
          </div>
        </form>

        <div className="panel panel-default">
          <div className="panel-heading" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          </div>
          <div className="table-responsive">
            <table className="table table-striped table-bordered" style={{ marginBottom: 0 }}>
              <thead>
                <tr>
                  <th style={{ width: "40%" }}>Source</th>
                  <th style={{ width: "15%" }} className="text-right">Posted</th>
                  <th style={{ width: "15%" }} className="text-right">Pending</th>
                  <th style={{ width: "15%" }} className="text-right">Deleted</th>
                  <th style={{ width: "15%" }} className="text-right">Total</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      <i className="fas fa-spinner fa-spin"></i> Loading...
                    </td>
                  </tr>
                ) : rows.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No records found
                    </td>
                  </tr>
                ) : (
                  rows.map((row) => {
                    const posted = Number(row.posted_count) || 0;
                    const pending = Number(row.pending_count) || 0;
                    const deleted = Number(row.deleted_count) || 0;
                    return (
                      <tr key={row.source}>
                        <td>{row.source}</td>
                        <td className="text-right">{posted}</td>
                        <td className="text-right">{pending}</td>
                        <td className="text-right">{deleted}</td>
                        <td className="text-right">{posted + pending + deleted}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
              {!loading && rows.length > 0 && (
                <tfoot>
                  <tr>
                    <th>Total</th>
                    <th className="text-right">{totals.posted || 0}</th>
                    <th className="text-right">{totals.pending || 0}</th>
                    <th className="text-right">{totals.deleted || 0}</th>
                    <th className="text-right">{(totals.posted || 0) + (totals.pending || 0) + (totals.deleted || 0)}</th>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminSourceWisePostingReport;
